import { FC } from 'react';
import {
  Box,
  HStack,
  Icon,
  IconName,
  NavigationButton,
  Spacer,
  Text,
  VStack,
} from '@wegroup/design-system';
import { useTranslation } from 'react-i18next';
import AnvaProductCartWidget from '@flows/src/components/flow-products/quotes/cart/AnvaProductCartWidget';

export interface FlowProductsSidebarItem {
  key: string;
  label: string;
  iconName?: IconName;
}

interface Props {
  items: FlowProductsSidebarItem[];
  activeItem: string;
  onItemClick: (key: string) => void;
  isHidden?: boolean;
}

const FlowProductsSidebar: FC<Props> = ({
  items,
  activeItem,
  onItemClick,
  isHidden,
}) => {
  const { t } = useTranslation();
  const width = isHidden ? '0' : { base: '2xs', laptopL: 'xs' };
  const px = isHidden ? '0' : '4';
  const borderRight = isHidden ? '0' : '1px';

  return (
    <Box position="relative">
      {/* This box makes sure the content on the right side is shown with the correct marginleft */}
      <Box w={width} visibility="hidden" transition="0.5s" />
      <VStack
        w={width}
        transition="0.5s"
        align="stretch"
        overflow="hidden"
        bg="white"
        py="9"
        px={px}
        h="100%"
        spacing="6"
        borderRight={borderRight}
        borderColor="gray.50"
        transform="auto"
        position="fixed"
        top="0"
      >
        <Text textStyle="normalBodyMedium" w="xs">
          {t('FLOW_PRODUCTS_SIDEBAR_TITLE')}
        </Text>
        <VStack align="stretch" spacing="2">
          {items.map((item) => {
            const { iconName, key } = item;
            const isActive = activeItem === key;
            return (
              <NavigationButton
                key={key}
                onClick={() => onItemClick(key)}
                size="md"
                isActive={isActive}
              >
                <HStack>
                  {iconName && (
                    <Box
                      color={isActive ? 'primary.500' : 'gray.500'}
                      transition="0.2s"
                    >
                      <Icon name={iconName} />
                    </Box>
                  )}
                  <Text>{item.label}</Text>
                </HStack>
              </NavigationButton>
            );
          })}
        </VStack>
        <Spacer />
        <AnvaProductCartWidget />
      </VStack>
    </Box>
  );
};

export default FlowProductsSidebar;
